import * as tslib_1 from "tslib";
/** @jsx withSlots */
import * as React from 'react';
import { withSlots, getSlots } from '@uifabric/foundation';
import { Stack } from 'office-ui-fabric-react';
export var CardSectionView = function (props) {
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    if (React.Children.count(children) < 1) {
        return null;
    }
    var Slots = getSlots(props, {
        root: Stack
    });
    return withSlots(Slots.root, tslib_1.__assign({}, rest), children);
};
//# sourceMappingURL=CardSection.view.js.map